import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {BreadCrumbAndDataResolverService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-resolver.service';
import {BreadCrumbAndDataHelperService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-helper.service';
import {FieldGroupService} from '../services/field-group/field-group.service';
import {FieldGroup} from '../interfaces/FieldGroup';

@Injectable()
export class FieldGroupNameResolverService extends BreadCrumbAndDataResolverService<FieldGroup> {
  constructor(private fieldGroupService: FieldGroupService, helper: BreadCrumbAndDataHelperService) {
    super(helper);
  }

  public async getData(route: ActivatedRouteSnapshot): Promise<FieldGroup> {
    return await this.fieldGroupService.getFieldGroup(Number(route.params.id));
  }

  public getName(data: FieldGroup): string {
    return `${data.name}`;
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/resolvers/field-group-name-resolver.service.ts